import type { ReactNode } from 'react'
import styles from './JobCreationQuestions.module.css'
import { Spinner } from '@/components/Spinner'

export interface JobCreationQuestionsProps {
  isLoading: boolean
  children?: ReactNode
}

export function JobCreationQuestions({
  isLoading,
  children,
}: JobCreationQuestionsProps) {
  return (
    <div className={styles.root}>
      {children}

      {isLoading && (
        <div className={styles.loading}>
          <Spinner />
        </div>
      )}
    </div>
  )
}
